import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewUserPlanForm } from '../sharedComponents/AddUserPlanFormICCID'

interface UserPlanDialogProps {
  userPlanDialogOpen: boolean
  userId: string
  iccid: string
  handleUserPlanDialogClose: () => void
}

export default function AddUserPlanDialog({
  userId,
  iccid,
  userPlanDialogOpen,
  handleUserPlanDialogClose
}: UserPlanDialogProps) {
  //handle form submit api here
  return (
    <div>
      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={() => handleUserPlanDialogClose()}
        aria-labelledby='customized-dialog-title'
        open={userPlanDialogOpen}
      >
        <BootstrapDialogTitle onClose={() => handleUserPlanDialogClose()}>
          Add a new user plan for iccid: {iccid}
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ height: '60vh' }}>
          <NewUserPlanForm
            handleClose={handleUserPlanDialogClose}
            userId={userId}
            iccid={iccid}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
